import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as AntTooltip } from "antd";
import "./Tooltip.scss";
export const Tooltip = (_a) => {
    var { hideArrow } = _a, props = __rest(_a, ["hideArrow"]);
    return (_jsx(AntTooltip, Object.assign({ arrow: !hideArrow }, props)));
};
